<script setup lang="ts">
const props = defineProps<{ value: 0 | 1 | 2 | 3 }>();
const emit = defineEmits<{ (e: "update:value", v: 0 | 1 | 2 | 3): void }>();

const pills: Array<{ label: string; v: 0 | 1 | 2 | 3; accent: string }> = [
  { label: "All", v: 0, accent: "bg-slate-900 text-white" },
  { label: "Pot 1", v: 1, accent: "bg-pot1 text-amber-950" },
  { label: "Pot 2", v: 2, accent: "bg-pot2 text-sky-950" },
  { label: "Pot 3", v: 3, accent: "bg-pot3 text-orange-950" },
];
</script>

<template>
  <div class="inline-flex rounded-lg ring-1 ring-slate-200 bg-white shadow-sm p-1 gap-1">
    <button
      v-for="p in pills"
      :key="p.v"
      type="button"
      class="px-3 py-1 text-sm rounded-md transition"
      :class="props.value === p.v ? p.accent + ' font-semibold shadow-sm' : 'text-slate-500 hover:text-slate-900'"
      @click="emit('update:value', p.v)"
    >{{ p.label }}</button>
  </div>
</template>
